import { orderBy } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { IUser94013 } from "../../../common/types";
import { Form, Select } from "../../atoms";
import { UserSelectedFieldWrapper } from "./Fields.style";

interface IUserSelectedFieldProps {
  bordered?: boolean;
  name: string | Array<string | number>;
  label?: string;
  rules?: any[];
  placeholder?: string;
  style?: any;
  mode?: "multiple" | "tags";
  maxTagCount?: number;
  initialValue?: any;
  getUser?: () => IUser94013;
  onChange?: (value: any) => void;
}
export const UserSelectedField: React.FC<IUserSelectedFieldProps> = ({
  name,
  label,
  mode,
  rules,
  getUser,
  onChange,
  bordered = true,
  style,
  placeholder,
  maxTagCount,
  initialValue,
}) => {
  const { user94013 } = useSelector((state: any) => state.user94013);

  return (
    <UserSelectedFieldWrapper>
      <Form.Item
        label={label}
        name={name}
        rules={rules}
        initialValue={initialValue}
      >
        <Select
          showSearch
          bordered={bordered}
          style={style}
          placeholder={placeholder || label}
          optionFilterProp="label"
          filterOption={(input, option: any) =>
            option.search.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          options={orderBy(user94013, ["name"], ["asc"]).map(
            (user: IUser94013) => ({
              value: user.id,
              label: user.name,
              search: `${user?.name || ""}`,
            })
          )}
          mode={mode}
          maxTagCount={maxTagCount}
          onChange={onChange}
        ></Select>
      </Form.Item>
    </UserSelectedFieldWrapper>
  );
};

export default UserSelectedField;
